import React from "react";
import { Link } from "react-router-dom";
import { Nav } from "@/components/layout/Nav";
import { Footer } from "@/components/layout/Footer";
import { PageSEO } from "@/components/seo/PageSEO";
import { SITE_URL } from "@/utils/seo";
import { ArrowRight, Home } from "lucide-react";

const SITE = SITE_URL;

export default function NotFound() {
  return (
    <>
      <PageSEO
        title="Page Not Found | Enchanted Gear Rentals"
        description="The page you are looking for could not be found."
        canonical={SITE}
        noIndex
      />
      <Nav />
      <main className="min-h-screen flex flex-col items-center justify-center text-center px-4 pb-20" style={{ background: "#040A0F" }}>
        <div className="text-[#FFD166]/20 text-[9rem] font-bold leading-none select-none mb-4">404</div>
        <h1 className="font-serif text-3xl md:text-4xl text-[#F6F1E4] mb-4">Page not found</h1>
        <p className="text-[#B9C8D5] mb-10 max-w-md">
          The page you are looking for does not exist or may have moved. Here are some helpful links to get you back on your way.
        </p>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 max-w-2xl w-full mb-10">
          {[
            { label: "Stroller Rentals", to: "/strollers", desc: "Browse our full stroller catalog" },
            { label: "Baby Gear Rentals", to: "/", desc: "Cribs, high chairs and more" },
            { label: "ECV Rentals", to: "/", desc: "Mobility scooter rentals" },
            { label: "Delivery Areas", to: "/delivery", desc: "Where we deliver" },
            { label: "Disney World Strollers", to: "/disney-world-stroller-rentals", desc: "Strollers for your Disney trip" },
            { label: "Contact Us", to: "/contact", desc: "Call, text or email us" },
          ].map((item) => (
            <Link key={item.label} to={item.to} className="group rounded-xl bg-[#0A1825] border border-[#FFD166]/10 hover:border-[#FFD166]/40 p-4 text-left transition-all">
              <div className="font-semibold text-[#F6F1E4] group-hover:text-[#FFD166] transition-colors text-sm">{item.label}</div>
              <div className="text-xs text-[#B9C8D5] mt-0.5">{item.desc}</div>
            </Link>
          ))}
        </div>
        <Link to="/"><button className="btn-primary" data-testid="not-found-home-btn"><Home className="inline w-4 h-4 mr-1" /> Back to Home <ArrowRight className="inline w-4 h-4 ml-1" /></button></Link>
      </main>
      <Footer />
    </>
  );
}
